<template>
	<sf-modal-layout
		class="register-reporting-point__popup"
		size="xl"
		:title="getMessage_('SWCC000585')"
		:show="show_"
		:closeModal="closeModal"
	>
		<el-form :model="selectedRow" label-width="122px">
			<el-form-item :label="getMessage_('SWCC000588')" :prop="stnCd_" :rules="[{ required: true, message: 'StationCode is required' }]">
				<el-input
					:readonly="disabled"
					:value="selectedRow.stnCd"
					:style="{ width: '160px', marginRight: '10px' }"
					@input="value => onChange({ key: 'stnCd', value })"
				/>
			</el-form-item>
			<el-form-item :label="getMessage_('SWCC000589')" :prop="stnName_" :rules="[{ required: true, message: 'StationName is required' }]">
				<el-input
					:value="selectedRow.stnName"
					:style="{ width: '160px', marginRight: '10px' }"
					@input="value => onChange({ key: 'stnName', value })"
				/>
			</el-form-item>

			<div :style="{ display: 'flex', width: '100%' }">
				<el-form-item :label="getMessage_('SWCC000590')" :rules="[{ required: true, message: 'Shop is required' }]">
					<el-select :value="selectedRow.shopCd" :style="{ width: '160px' }" @change="value => onChange({ key: 'shopCd', value })">
						<el-option v-for="option in shopCds_" :key="option.value" :label="option.label" :value="option.value" />
					</el-select>
				</el-form-item>
				<el-form-item :label="getMessage_('SWCC000591')" :rules="[{ required: true, message: 'Line is required' }]">
					<el-select :value="selectedRow.lineCd" :style="{ width: '160px' }" @change="value => onChange({ key: 'lineCd', value })">
						<el-option v-for="option in lines_" :key="option.value" :label="option.label" :value="option.value" />
					</el-select>
				</el-form-item>
			</div>
			<div :style="{ display: 'flex', width: '100%' }">
				<el-form-item :label="getMessage_('SWCC000592')">
					<el-select :value="selectedRow.cid" :style="{ width: '100px' }" @change="value => onChange({ key: 'cid', value })">
						<el-option v-for="option in cids_" :key="option.value" :label="option.label" :value="option.value" />
					</el-select>
				</el-form-item>

				<el-form-item :label="getMessage_('SWCC000593')">
					<el-select :value="selectedRow.hid" :style="{ width: '100px' }" @change="value => onChange({ key: 'hid', value })">
						<el-option v-for="option in hids_" :key="option.value" :label="option.label" :value="option.value" />
					</el-select>
				</el-form-item>

				<el-form-item :label="getMessage_('SWCC000594')">
					<el-select :value="selectedRow.bid" :style="{ width: '100px' }" @change="value => onChange({ key: 'bid', value })">
						<el-option v-for="option in bids_" :key="option.value" :label="option.label" :value="option.value" />
					</el-select>
				</el-form-item>

				<el-form-item :label="getMessage_('SWCC000595')">
					<el-select :value="selectedRow.tid" :style="{ width: '100px' }" @change="value => onChange({ key: 'tid', value })">
						<el-option v-for="option in tids_" :key="option.value" :label="option.label" :value="option.value" />
					</el-select>
				</el-form-item>

				<el-form-item :label="getMessage_('SWCC000811')">
					<el-select :value="selectedRow.aid" :style="{ width: '100px' }" @change="value => onChange({ key: 'aid', value })">
						<el-option v-for="option in aids_" :key="option.value" :label="option.label" :value="option.value" />
					</el-select>
				</el-form-item>
			</div>
			<div :style="{ display: 'flex' }">
				<el-form-item :label="getMessage_('SWCC000596')">
					<sf-card class="p-0 border-0 bg-transparent">
						<el-checkbox
							v-for="(item, index) in flagInfo"
							:key="index"
							:value="popupParams.selectedRow[item.commCd.toLowerCase()] === 'Y'"
							:style="{ whiteSpace: 'nowrap' }"
							@change="value => onChange({ key: item.commCd.toLowerCase(), value: value ? 'Y' : 'N' })"
						>
							<!-- {{ getMessage_(item.commCdDesc) }} -->
							{{ item.commCdName }}
						</el-checkbox>
					</sf-card>
				</el-form-item>
			</div>
			<div :style="{ display: 'flex', width: '100%' }">
				<el-form-item :label="getMessage_('SWCC000597')">
					<el-input :value="selectedRow.fairStock" :style="{ width: '160px' }" @input="value => onChange({ key: 'fairStock', value })" />
				</el-form-item>

				<el-form-item :label="getMessage_('SWCC000598')">
					<el-input :value="selectedRow.maxStock" :style="{ width: '160px' }" @input="value => onChange({ key: 'maxStock', value })" />
				</el-form-item>

				<el-form-item :label="getMessage_('SWCC000599')">
					<el-input :value="selectedRow.minStock" :style="{ width: '160px' }" @input="value => onChange({ key: 'minStock', value })" />
				</el-form-item>
			</div>
		</el-form>
		<!-- && popupParams.type === 'create' ? true : false -->
		<!-- isButton_(scrId,'AD') -->
		<template v-slot:footer>
			<sf-button
				v-if="isButton_(scrId, 'AD') && popupParams.type === 'create'"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000555'),
							buttons: [{ title: getMessage_('SWCC000245'), clickFn: registerStation }]
						})
				"
				>{{ getMessage_('SWCC000245') }}</sf-button
			>
			<!-- popupParams.type === 'update' ? true : false &&  -->
			<!-- isButton_(scrId,'AD') -->
			<sf-button
				v-if="isButton_(scrId, 'AD') && popupParams.type === 'update'"
				v-show="disabled"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000553'),
							buttons: [{ title: getMessage_('SWCC000279'), clickFn: modifyStation }]
						})
				"
				>{{ getMessage_('SWCC000279') }}</sf-button
			>
			<sf-button
				v-if="popupParams.type === 'update' && isButton_(scrId, 'CD')"
				v-show="disabled"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000554'),
							buttons: [{ title: getMessage_('SWCC000280'), clickFn: removeStation }]
						})
				"
				>{{ getMessage_('SWCC000280') }}</sf-button
			>
			<sf-button line :onClick="closeModal">{{ getMessage_('SWCC000243') }}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/RegisterReportingPoint/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			flags: []
		};
	},
	created() {
		this.$sf_toggleLoading(true);
		this.fetchLines_({ plantCd: this.user.plantCd }).finally(() => this.$sf_toggleLoading(false));
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		closeModal() {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					type: '',
					show: false,
					selectedRow: {}
				}
			});
		},
		onChange({ key, value }) {
			let adjustValue = value;
			if (key == 'stnCd' || key == 'stnName') {
				//console.log('key');
				const replaceChar = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;
				adjustValue = adjustValue.replace(replaceChar, '');

				// adjustValue = adjustValue.replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi, '');
			}
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					...this.popupParams,
					selectedRow: {
						...this.selectedRow,
						[key]: adjustValue
					}
				}
			});
		},
		registerStation() {
			try {
				this.schema.validateSync(this.selectedRow);

				this.$sf_toggleLoading(true);
				if (this.selectedRow.plantCd == null || this.selectedRow.plantCd === '') {
					this.selectedRow.plantCd = this.searchParams.plantCd ? this.searchParams.plantCd : this.user.plantCd;
				}
				this.createStation_({ station: this.selectedRow })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchStations_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		modifyStation() {
			try {
				this.schema.validateSync(this.selectedRow);

				this.$sf_toggleLoading(true);
				if (this.selectedRow.plantCd == null || this.selectedRow.plantCd === '') {
					this.selectedRow.plantCd = this.searchParams.plantCd ? this.searchParams.plantCd : this.user.plantCd;
				}
				this.updateStation_({ station: this.selectedRow })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchStations_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		removeStation() {
			try {
				this.schema.validateSync(this.selectedRow);

				this.$sf_toggleLoading(true);
				this.deleteStation_({ station: this.selectedRow })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchStations_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		selectedRow() {
			const { selectedRow } = this.popupParams;
			return selectedRow;
		},
		disabled() {
			const { type } = this.popupParams;
			return type.includes('update');
		},
		schema() {
			const replaceChar = /[~!@\#$%^&*\()\-=+_'\;<>0-9\/.\`:\"\\,\[\]?|{}]/gi;

			return yup.object().shape({
				// lineCd: yup.string().nullable().required(this.getMessage_('SWCC000697')),
				shopCd: yup.string().nullable().required(this.getMessage_('SWCC000696')),
				stnName: yup
					.string()
					.nullable()
					.required(this.getMessage_('SWCC000695'))
					.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('SWCC000689'), 1]))
					.max(50, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000689'), 50])),
				stnCd: yup
					.string()
					.nullable()
					.required(this.getMessage_('SWCC000694'))
					.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('SWCC000688'), 1]))
					.max(20, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000688'), 20]))
			});
		}
	}
};
</script>

<style langType="scss"></style>
